import { convexClient } from "../config/convex";
import { api } from "../../convex/_generated/api";

export interface EmailLog {
  id?: string;
  to: string;
  subject: string;
  sentAt: string;
  status: "success" | "error";
  error?: string | null;
}

const CONFIG_DOC_ID = "notifications";
const SMTP_CONFIG_DOC_ID = "smtp";

export interface SmtpConfig {
  host: string;
  port: number;
  secure: boolean;
  user: string;
  password: string;
  fromEmail: string;
  fromName: string;
}

export const initializeConfigTables = async (): Promise<void> => {
  // Convex schema is managed by convex/schema.ts; no-op for Convex
  return Promise.resolve();
};

export const configService = {
  async getNotificationEmail(): Promise<string | null> {
    return await convexClient.query(api.config.getNotificationEmail, {});
  },

  async setNotificationEmail(email: string): Promise<void> {
    await convexClient.mutation(api.config.setNotificationEmail, { email });
  },

  async getSmtpConfig(): Promise<SmtpConfig | null> {
    const raw = await convexClient.query(api.config.getSmtpConfig, {});
    return raw as SmtpConfig | null;
  },

  async setSmtpConfig(config: SmtpConfig): Promise<void> {
    await convexClient.mutation(api.config.setSmtpConfig, {
      config_data: JSON.stringify(config),
    });
  },

  async logEmailSent(emailLog: Omit<EmailLog, "id">): Promise<string> {
    const id = await convexClient.mutation(api.emailLogs.add, {
      to_email: emailLog.to,
      subject: emailLog.subject,
      sent_at: emailLog.sentAt,
      status: emailLog.status,
      error: emailLog.error ?? undefined,
    });
    return String(id);
  },

  async getEmailLogs(
    _month?: number,
    _year?: number,
    includeTestEmails: boolean = true
  ): Promise<EmailLog[]> {
    const logs = await convexClient.query(api.emailLogs.list, { limit: 100 });
    return logs.map((log) => ({
      id: log._id,
      to: log.to_email,
      subject: log.subject,
      sentAt: log.sent_at,
      status: log.status as "success" | "error",
      error: log.error ?? null,
    }));
  },
};

